module.exports = __webpack_public_path__ + "img/ic_qmarker_dumpster_lbl_issue.6acce563.png";